$(document).ready(function() {
    const perNav = $("#mainNavigation ul > li");
    const borderBlock = document.getElementById("navChaser");

    // onHover events
    perNav.hover(

        //mouseover
        function() {
            //Get the positionX of nav which is hovered.
            //Then turn the value to Integer
            let getOffsetX = this.offsetLeft;
            let getWidth = this.offsetWidth;

            // #navChaser change positionX and fadeIn
            borderBlock.style.transform = `translateX(${getOffsetX}px)`;
            borderBlock.style.width = `${getWidth}px`;
            borderBlock.style.opacity = 1;
        },

        //mouseout
        function() {
            borderBlock.style.opacity = 0;
        }
    );

});